module.exports = __webpack_public_path__ + "static/media/nav4_yt_hover.4031bb60.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/nav4_yt_hover.png
// module id = 244
// module chunks = 0